module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/menu_order-d6cc535bf000da569ae996f6ac090538.png";